module.exports = __webpack_public_path__ + "img/IDCard5.5b5349bb.png";